import Service, { inject as service } from '@ember/service';
import { PAGINATION_DEFAULT_COUNT_PER_PAGE } from 'sh-www/constants/routes/reports';

export default class ShGeneralInvoiceCommands extends Service {
  @service api;

  /**
   *
   * @param companyId
   * @param amountInCents
   * @param costCodeId
   * @param memo
   * @returns {*}
   */
    loadShGeneralInvoices({
      user_id,
      page = 1,
      sort,
      secondary_sort,
      cache_key,
      count = PAGINATION_DEFAULT_COUNT_PER_PAGE,
      includes = [],
      filters = {},
    }) {
      const params = {
        user_id,
        page,
        count,
      }

      if (sort) {
        params['sort'] = sort;
      }

      if (secondary_sort) {
        params['secondary_sort'] = secondary_sort;
      }

      if (cache_key) {
        params['cache_key'] = cache_key;
      }

      if (includes) {
        params['include'] = includes.join(',');
      }

      if (filters) {
        params['filter'] = filters;
      }

      return this.api.get('sh-general-invoices',  { params });
    }

  /**
   *
   * @param companyId
   * @param amountInCents
   * @param costCodeId
   * @param memo
   * @returns {*}
   */
  storeShGeneralInvoiceTransaction({
    shGeneralInvoiceId,
    amountInCents,
    paymentMethod,
    transactionDate,
    memo,
  }) {
    return this.api.post(`sh-general-invoices/${shGeneralInvoiceId}/sh-general-invoice-transaction`, {
      jsonData: {
        amount_in_cents: amountInCents,
        payment_method: paymentMethod,
        transaction_date: transactionDate,
        memo: memo,
      }
    })
  }
}
